function getDeviceInfo() {
    this.res = {};
    this.res.isPhone = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.res.width = window.innerWidth;
    this.res.height = window.innerHeight;
    this.res.isSmall = window.innerWidth < 900;

    this.listeners = [];

    document.addEventListener('resize', () => {
        this.res.width = window.innerWidth;
        this.res.height = window.innerHeight;
        this.res.isSmall = window.innerWidth < 900;
        this.listeners.map((func) => {
            try {
                func(this.res);
            } catch (e) {
            }
        });
    });

    this.addListener = (func) => {
        this.listeners.push(func);
    }
}

module.exports = getDeviceInfo;



// WEBPACK FOOTER //
// ./src/js/utils/ScreenSizeDetector.js